import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

type AutosizeTextareaProps = ComponentProps<typeof Textarea>;

export function AutosizeTextarea({ className, ...props }: AutosizeTextareaProps) {
  return (
    <Textarea
      className={cn(
        "min-h-20 max-h-[40vh] resize-none overflow-y-auto rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs",
        "placeholder:text-muted-foreground dark:bg-input/30",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
